"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _react = _interopRequireWildcard(require("react"));
var _FiltersModule = _interopRequireDefault(require("../../styles/components/Filters.module.css"));
var _hooks = require("../../hooks");
var _index = require("../index");
var _functions = require("../../utils/functions");
var _filter = require("../../icons/filter");
var _Search = _interopRequireDefault(require("../Inputs/Search"));
var _SelectField = _interopRequireDefault(require("./SelectField"));
var _ButtonField = _interopRequireDefault(require("./ButtonField"));
var _ResetButton = _interopRequireDefault(require("./ResetButton"));
var _material = require("@mui/material");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * ====================== properties ============================
 * @param {Array} data      - array of what needs to be filtered                    - require
 * @param {Array} config    - array of objects with settings for filtering fields   - require
 *             params of object:
 *             - text - type string, for types: button;
 *             - type - type string, type of field, available: button / select;
 *             - name - type string,
 *                      for which parameter is the filter,
 *                      for types: button, select;
 *             - value - type string or array of string,
 *                       value that the filter can find,
 *                       available: button / select;
 *             - id - type string or number, field id;
 *             - grouped - type bool,
 *                         for types: button,
 *                         flag for filters to work together by type "either - or";
 *             - showIf - --(not implemented)
 *  @example
 *
 * const config = [{
 *     text: 'Warnings',
 *     value: 'display_warnings',
 *     type: filterTypes.button,
 *     id: 0,
 *     // showIf: filters.warning && sites.length >= 7
 *   },{
 *     defaultValue: `City`,
 *     type: filterTypes.select,
 *     value: 'city',
 *     id: 1,
 *    },{
 *      defaultValue: `Zip`,
 *      type: filterTypes.select,
 *      value: 'zip',
 *      id: 2,
 *    },
 *    {
 *         placeholder: 'Enthält Text',
 *         type: filterTypes.search,
 *         className: '',
 *         sx: {maxWidth: '250px'},
 *         option: (item, tv) => `${tv(item.thingSiteAddress || '')}, ${tv(item.thingZIPCode || '')} ${tv(item.thingCity || '')}`,
 *         id: 3
 *     },
 *    ]
 *
 * @param {s} activeFilters    - control activeFilter param,
 * @param {boolean} showFilterIcon   - do need to display the filtering icon
 * @param {styles} classNameWrap    - class name for the entire component
 * @param {styles} className        - class name for the filtering fields panel
 * @param {JSX.Element} children         - child element to be filtered,  gets the parameter "filteredData" && 'filteredIdList'   - require  // !!!! need to change only filteredIdList *for optimization)
 * @param {JSX.Element} inlineChildren   - child element that is in the same row with the filtering fields
 * @param {string} theme            - styles theme - light (default) | dark
 *
 * @param {function} getFilteredData  - get actual filteredData value
 * @param {function} getFilterTypes   - get actual filterTypes value
 * @param {function} getActiveFilters - get actual activeFilters value
 *
 * @returns {JSX.Element}
 * @public
 */

const Filters = _ref => {
  let {
    data = [],
    config = [],
    showFilterIcon = true,
    classNameWrap = {},
    className,
    activeFilters: propActiveFilter = null,
    children = null,
    inlineChildren = null,
    theme = _constants.defaultTheme,
    objectId = 'id',
    getFilteredData = d => d,
    getFilterTypes = t => t,
    getActiveFilters = f => f
  } = _ref;
  const [activeFilters, saveActiveFilters] = (0, _react.useState)({});
  const [filterTypes, setFilterTypes] = (0, _react.useState)([]);
  const filterPanelData = (0, _hooks._useCreateFiltersByParam)({
    types: ['thingCity', 'thingZIPCode', 'warning'],
    data,
    activeFilters
  }) || {};
  const {
    filteredData,
    filteredIdList
  } = (0, _hooks._useFilterList)({
    activeFilters,
    data,
    filterTypes,
    objectId,
    config
  });
  (0, _react.useEffect)(() => {
    getFilteredData(filteredData);
  }, [filteredData]);
  (0, _react.useEffect)(() => {
    getFilterTypes(filterTypes);
  }, [filterTypes]);
  (0, _react.useEffect)(() => {
    getActiveFilters(activeFilters);
  }, [activeFilters]);
  (0, _react.useEffect)(() => {
    setFilterTypes(config.map(c => c.name));
  }, [config]);
  (0, _react.useEffect)(() => {
    if (propActiveFilter) saveActiveFilters(propActiveFilter);
  }, [propActiveFilter]);
  const isIncludes = (0, _react.useCallback)(_ref2 => {
    let {
      value = null,
      name = null,
      type = '',
      grouped = false
    } = _ref2;
    const hasKey = Object.keys(activeFilters).includes(name);
    const hasValue = !!(activeFilters[name] ? (0, _functions.isArray)(activeFilters[name]) ? activeFilters[name] : [activeFilters[name]] : []).find(filter => !(0, _functions.diff)((0, _functions.isArray)(value) ? value : [value], (0, _functions.isArray)(filter) ? filter : [filter]).length);
    return hasKey && (type === _constants.filterTypes.button ? hasValue : true);
  }, [activeFilters]);
  const updateSelector = (0, _react.useCallback)((item, value) => {
    saveActiveFilters(_objectSpread(_objectSpread({}, activeFilters), {}, {
      [item.name]: value
    }));
  }, [activeFilters, saveActiveFilters]);
  const updateActiveFilter = (0, _react.useCallback)(_ref3 => {
    let {
      name,
      value,
      type,
      grouped
    } = _ref3;
    if (isIncludes({
      name,
      grouped,
      type,
      value
    })) {
      if (grouped) {
        const newValue = activeFilters[name].filter(f => value !== f);
        if (newValue.length) {
          saveActiveFilters(_objectSpread(_objectSpread({}, activeFilters), {}, {
            [name]: newValue
          }));
        } else {
          saveActiveFilters(Object.keys(activeFilters).reduce((acc, n) => n !== name ? _objectSpread(_objectSpread({}, acc), {}, {
            [n]: activeFilters[n]
          }) : acc, {}));
        }
      } else {
        saveActiveFilters(Object.keys(activeFilters).reduce((acc, n) => n !== name ? _objectSpread(_objectSpread({}, acc), {}, {
          [n]: activeFilters[n]
        }) : acc, {}));
      }
    } else saveActiveFilters(_objectSpread(_objectSpread({}, activeFilters), {}, {
      [name]: grouped ? [...(activeFilters[name] || []), value] : value || true
    }));
  }, [activeFilters, isIncludes]);
  const getField = (0, _hooks.useDeepCallback)(filter => {
    switch (filter.type) {
      case _constants.filterTypes.select:
        return /*#__PURE__*/_react.default.createElement(_SelectField.default, {
          key: filter.id,
          filter: filter,
          filterPanelData: filterPanelData,
          activeFilters: activeFilters,
          updateSelector: updateSelector,
          updateActiveFilter: updateActiveFilter,
          theme: theme
        });
      case _constants.filterTypes.button:
        return /*#__PURE__*/_react.default.createElement(_ButtonField.default, {
          key: filter.id,
          filter: filter,
          updateActiveFilter: updateActiveFilter,
          isIncludes: isIncludes,
          theme: theme
        });
      default:
        return null;
    }
  }, [filterPanelData, activeFilters, isIncludes, theme, updateActiveFilter, updateSelector]);

  // return useDeepMemo(() => {
  const searchData = config.find(filter => filter.type === _constants.filterTypes.search);
  const configWithoutSearch = config.filter(c => c.type !== _constants.filterTypes.search);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "".concat(classNameWrap)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-row flex-between ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "w-100 ".concat(_FiltersModule.default.filters_wrap, " ").concat(_FiltersModule.default[theme], " flex-row flex-top-center"),
    sx: {
      gap: '0 16px'
    }
  }, showFilterIcon ? /*#__PURE__*/_react.default.createElement(_filter.FilterSVG, {
    className: _FiltersModule.default.iconFilters,
    width: 25,
    height: 20
  }) : null, /*#__PURE__*/_react.default.createElement(_index.SwiperLayoutGrid, {
    className: _FiltersModule.default.swiper,
    keys: configWithoutSearch.map(c => c.id),
    navigation: false,
    spaceBetween: 16
  }, configWithoutSearch.map(filter => getField(filter))), searchData ? /*#__PURE__*/_react.default.createElement(_Search.default, _extends({
    theme: theme,
    list: filteredData,
    activeFilters: activeFilters,
    updateActiveFilters: saveActiveFilters
  }, searchData, {
    className: "".concat(_FiltersModule.default.search, " ").concat((searchData === null || searchData === void 0 ? void 0 : searchData.className) || '')
  })) : null, /*#__PURE__*/_react.default.createElement(_ResetButton.default, {
    activeFilters: activeFilters,
    saveActiveFilters: saveActiveFilters,
    theme: theme
  })), inlineChildren), _react.Children.map(children, child => {
    // Checking isValidElement is the safe way and avoids a typescript error too.
    if ( /*#__PURE__*/(0, _react.isValidElement)(child)) {
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        filteredIdList
      });
    } else return child;
  }));
  // }, [classNameWrap, className, config, showFilterIcon, activeFilters, filteredIdList, theme, getField, filterPanelData])
};
var _default = exports.default = Filters;